// Which ways a person can answer a challenge (task 387.11.6): one per factor, passkeys collapsed into one.

import type { MfaFactorOption } from '@/api/contracts/session';
import { MFA_METHOD_LABEL } from '@/api/endpoints/mfa';

export interface VerificationChoice {
  key: string;
  method: string;
  /** Absent for passkeys: the assertion names its own credential. */
  factorId?: string;
  label: string;
}

const PASSKEY_KEY = 'WEBAUTHN';
export const RECOVERY_KEY = 'RECOVERY';

/** One choice per factor, except passkeys which collapse into one. Most recently used first. */
export function verificationChoices(factors: MfaFactorOption[]): VerificationChoice[] {
  const byRecent = [...factors].sort((a, b) =>
    (b.lastUsedAt ?? b.createdDate).localeCompare(a.lastUsedAt ?? a.createdDate),
  );
  const choices: VerificationChoice[] = [];
  for (const factor of byRecent) {
    if (factor.method === 'WEBAUTHN') {
      if (!choices.some((c) => c.key === PASSKEY_KEY)) {
        choices.push({ key: PASSKEY_KEY, method: 'WEBAUTHN', label: 'Passkey' });
      }
      continue;
    }
    const methodLabel = MFA_METHOD_LABEL[factor.method] ?? factor.method;
    choices.push({
      key: factor.factorId,
      method: factor.method,
      factorId: factor.factorId,
      label:
        factor.label && factor.label !== methodLabel
          ? `${methodLabel} — ${factor.label}`
          : methodLabel,
    });
  }
  return choices;
}
